// Query options for Operator › Templates (DC-03): the catalog list, a template with its versions,
// a version with its evals and rules, and a template's edit proposals. Keys nest under
// `["operator", "agent-templates", …]`, so one invalidation reaches the whole catalog.
import { queryOptions } from "@tanstack/react-query";
import type { Api } from "../../../api/client";

export const templateKeys = {
  all: () => ["operator", "agent-templates"] as const,
  list: () => ["operator", "agent-templates", "list"] as const,
  detail: (id: string) => ["operator", "agent-templates", "detail", id] as const,
  version: (id: string) => ["operator", "agent-templates", "version", id] as const,
  proposals: (templateId: string) =>
    ["operator", "agent-templates", "proposals", templateId] as const,
};

/** The catalog fits one page (the API's limit is 200; the agency's own plus the platform's). */
export const agentTemplatesQuery = (api: Api) =>
  queryOptions({
    queryKey: templateKeys.list(),
    queryFn: () => api.client.operator.agentTemplates.list({ query: { limit: 200 } }),
  });

export const agentTemplateQuery = (api: Api, templateId: string) =>
  queryOptions({
    queryKey: templateKeys.detail(templateId),
    queryFn: () => api.client.operator.agentTemplates.get({ params: { template_id: templateId } }),
  });

export const templateVersionQuery = (api: Api, versionId: string) =>
  queryOptions({
    queryKey: templateKeys.version(versionId),
    queryFn: () => api.client.operator.templateVersions.get({ params: { version_id: versionId } }),
  });

export const templateProposalsQuery = (api: Api, templateId: string) =>
  queryOptions({
    queryKey: templateKeys.proposals(templateId),
    queryFn: () =>
      api.client.operator.templateEditProposals.list({
        query: { template_id: templateId, limit: 200 },
      }),
  });
